import * as React from 'react';
import ContainersService from '../../shared/services/ContainersService';
import {ApiResponse} from '../../shared/CommonInterfaces';
import {Inbound} from '../shared/InboundInterfaces';
import DropoffHelper from '../../dropoffs/shared/DropoffHelper';

interface Props {
  containersService: ContainersService;
  inbound: Inbound;
  handleApiError: (errors: string[], response: ApiResponse<any>) => void;
  reloadContainer: () => void;
}

export const AlteredInboundConfirmation: React.FC<Props> = (props) => {
  const {containersService, inbound, handleApiError, reloadContainer} = props;

  const confirmDelivery = async () => {
    const startTime = inbound.receivingWindow?.startAt;
    const endTime = inbound.receivingWindow?.endAt;

    const startTimeMs = DropoffHelper.hoursAndMinutesToMs(startTime);
    const endTimeMs = DropoffHelper.hoursAndMinutesToMs(endTime);

    const response = await containersService.confirmDelivery({
      id: inbound.id,
      startTime: startTimeMs,
      endTime: endTimeMs,
      instructions: inbound.instructions
    });

    if (response?.errors.length === 0) {
      reloadContainer();
    } else {
      handleApiError([`There was an error confirming delivery for inbound #${inbound.id}`], response);
    }
  };

  return (
    <div>
      <h2>Inbound Altered</h2>
      <p>
        The Shipper has modified this Inbound. Please carefully review the updated details below. If there are no
        conflicts, Accept Changes and the inbound will remain on schedule for completion with the updated and confirmed
        information.
      </p>
      <button className="btn cta btn-alter-confirm" onClick={confirmDelivery}>
        <i className="fa fa-angle-right"></i> Re-confirm Inbound
      </button>
      <hr />
    </div>
  );
};

export default AlteredInboundConfirmation;
